import { images } from '../../../Constants/ImageUrls';
import { downloadAppHandler } from '../../../Utils/redirections';
import { Comments } from '../../HomePage/Community/styled';
import { SBCFlex } from '../../QnaPage/QuestionWrapper/styled';
import {
  ParentingCommunityQ,
  UserQuestionImageSec,
  UserQwrapper,
} from '../../QnaPage/UserQuestion/styled';

export default function CommunityBody(props) {
  const { data, stage } = props;
  const image =
    data?.content?.webpImages?.[0] ||
    data?.content?.newFiles?.[0] ||
    data?.content?.feature_endorsed_doctor?.image;
  return (
    <UserQwrapper stage={stage}>
      <div className="userquestion">
        <ParentingCommunityQ>{data?.content?.message}</ParentingCommunityQ>
        {image ? (
          <UserQuestionImageSec>
            {' '}
            <img
              src={`${image}`}
              srcSet={`${image}?tr=w-720,q-80 1w, ${image}?tr=w-1000,q-80 2w`}
              sizes="(max-width: 720px) 1px,2px"
              loading="lazy"
              alt=""
            />
          </UserQuestionImageSec>
        ) : null}
      </div>
      <SBCFlex>
        <Comments
          onClick={downloadAppHandler}
          marginLeft="10px"
          paddingBottom="10px"
        >
          <img loading="lazy" src={images.comment} alt="" />
          <span>{data?.content?.comments}</span>
          <span>Answer</span>
        </Comments>
      </SBCFlex>
    </UserQwrapper>
  );
}
